import { api } from 'services/api'

export const getResources = async (resource) => {
  const response = await api.get(resource)
  return response.data.data
}
